import { Group } from '@mantine/core';
import { QueryObserverResult } from '@tanstack/react-query';
import { isArray } from 'lodash';
import * as React from 'react';
import { ResourceType } from '../../../resource/enumerations/ResourceType';
import { PersistableInfo } from '../../../resource/resource-base/persistableResourceTypes';
import { DetailedValidationResource } from '../../../resource/resources/validation/detailedValidationResource';
import { ValidationResultSet } from '../../../resource/services/backgroundTaskResource';
import { MetaDataButton } from './MetaDataButton';
import { ResourceDetailsButton } from './ResourceDetailsButton';
import { ResourceDetailsWithMultiValidationButton } from './ResourceDetailsWithMultiValidationButton';

// TODO take n number of validation results
export const ResourceValidationTitleBar= ({
    resourceType,
    resourceValidationResult,
    children,
    customButtons,
    metaDataInfo,
    versionMetaDataInfo,
    buttonStyle,
}: {
    resourceValidationResult?: DetailedValidationResource | DetailedValidationResource[];
    resourceType?: ResourceType | ResourceType[];
    dependencyValidationResultFunction?: (id?: string | undefined) => QueryObserverResult<ValidationResultSet | null>;
    metaDataInfo?: {
        id: string;
        objectId: string;
        persistableInfo: PersistableInfo;
    } | null;
    versionMetaDataInfo?: {
        id: string;
        objectId: string;
        persistableInfo: PersistableInfo;
    } | null;
    buttonStyle?: React.CSSProperties;
    customButtons?: React.ReactNode | React.ReactNode[];
    children: React.ReactNode | React.ReactNode[]; // TODO disallow children, add label which is automatically rendered in Text component
}) => {
    return (
        <div style={{ display: 'inline-flex', width: '100%' }}>
            <div style={{ display: 'inline-flex', flexGrow: 1 }}>{children}</div>
            <Group justify="flex-end" gap={6} style={{ display: 'inline-flex', alignItems: 'center' }}>
                {customButtons}
                {/*{dependencyValidationResultFunction && resourceId && (*/}
                {/*    <DependencyValidationButton*/}
                {/*        resourceId={resourceId}*/}
                {/*        dependencyValidationResultFunction={dependencyValidationResultFunction}*/}
                {/*    />*/}
                {/*)}*/}
                {metaDataInfo && (
                    <MetaDataButton
                        style={buttonStyle}
                        metaDataInfo={metaDataInfo}
                        versionMetaDataInfo={versionMetaDataInfo}
                    />
                )}
                {isArray(resourceValidationResult) ?
                    <ResourceDetailsWithMultiValidationButton
                        resourceValidationResults={resourceValidationResult}
                        resourceType={resourceType}
                    />
                : resourceType ?
                    <ResourceDetailsButton
                        style={buttonStyle}
                        resourceValidationResult={resourceValidationResult}
                        resourceType={resourceType}
                    />
                :   undefined}
            </Group>
        </div>
    );
};


